import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl, useAppRoutes } from '@webapp/hooks'
import messages from './messages'

const UnitTypeManagementViewChunk = React.lazy(() =>
  import('../../feature-sets/UnitTypeManagementView').then(
    ({ UnitTypeManagementView }) => ({
      default: UnitTypeManagementView,
    })
  )
)

export const CustomizeUnitTypesPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.customizeUnitTypesTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          link: url('CustomizeUnitTypesPage'),
          name: intl.formatMessage(messages.customizeUnitTypesTitle),
        },
      ]}
    >
      <React.Suspense fallback={null}>
        <UnitTypeManagementViewChunk />
      </React.Suspense>
    </Page>
  )
}
